var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReloaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85346,9.17284A8.80224,8.80224,0,1,1,13.1988,20.77722a.58937.58937,0,0,1,0-1.17874A7.62247,7.62247,0,1,0,6.072,9.26657l1.97053.15158a.39291.39291,0,0,1,.26556.65049L5.28266,13.52626A.39292.39292,0,0,1,4.66,13.48547L2.06683,9.59565a.39291.39291,0,0,1,.35706-.6097Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloaded);
export default __webpack_public_path__ + "static/media/reloaded.5518e242e2f228ec09f5508651a5ff69.svg";
export { ForwardRef as ReactComponent };